module.exports = __webpack_public_path__ + "img/maria-half.08697c53.png";